"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var StackingRoot_1 = require("../config/StackingRoot");
var Declarative_1 = require("../utils/Declarative");
var ReactHelpers_1 = require("./ReactHelpers");
var PortalEventTrap_1 = require("./PortalEventTrap");
/**
 * The stacking component maintains the lifecycle of its child by appending/rendering into the stacking root,
 * and unmounting the child when the stacking component is unmounting.
 */
var StackingComponentWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(StackingComponentWrapper, _super);
    function StackingComponentWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.stackingRoot = _this.props.stackingRootId ? document.getElementById(_this.props.stackingRootId) :
            StackingRoot_1.StackingRootConfig.getDefaultRootContainer();
        if (!_this.stackingRoot) {
            throw Error('Could not find stacking root.');
        }
        _this.warnIfRootIsNotPositioned();
        _this.createMountPoint();
        return _this;
    }
    StackingComponentWrapper.prototype.warnIfRootIsNotPositioned = function () {
        if (this.stackingRoot === document.body) {
            return;
        }
        var position = window.getComputedStyle(this.stackingRoot).position;
        if (position !== 'relative' && position !== 'absolute') {
            throw Error("Root Container does not have relative or absolute positioning.  Since some shared widgets absolutely\n      position relative to the container this may interfere with positioning");
        }
    };
    StackingComponentWrapper.prototype.componentDidMount = function () {
        this.stackingRoot.appendChild(this.mountPoint);
    };
    StackingComponentWrapper.prototype.componentWillUnmount = function () {
        this.stackingRoot.removeChild(this.mountPoint);
    };
    StackingComponentWrapper.prototype.getMountPoint = function () {
        return this.mountPoint;
    };
    /**
     * Create the mount point where the stacked element will be mounted and append it to the stacking root.  It should align
     * with the top/left of the stacking root as to align the positioning of stacked elements with the stacking root.  This prevents
     * cases where there are relatively positioned elements above the mount point, thus making the top of the mount point below the top
     * of the stacking root.
     */
    StackingComponentWrapper.prototype.createMountPoint = function () {
        if (!this.mountPoint) {
            this.mountPoint = document.createElement('div');
            this.mountPoint.style.zIndex = "" + this.props.zIndex;
            this.mountPoint.style.position = 'absolute';
            this.mountPoint.style.top = '0';
            this.mountPoint.style.left = '0';
            this.mountPoint.setAttribute('data-tb-test-id', Declarative_1.testId(this.props.wrapperTestId, 'Root'));
        }
    };
    StackingComponentWrapper.prototype.render = function () {
        return ReactDOM.createPortal(PortalEventTrap_1.PortalEventTrap(React.Children.only(this.props.children), this.props.portalEventTrapOverrides), this.mountPoint);
    };
    return StackingComponentWrapper;
}(React.Component));
exports.StackingComponentWrapper = StackingComponentWrapper;
exports.StackingComponentHOC = function (componentType) {
    var componentClass = ReactHelpers_1.convertToStatefulComponentClass(componentType);
    var newComponentClass = /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(StackingComponentWrapper, this.props, _super.prototype.render.call(this));
        };
        return class_1;
    }(componentClass));
    newComponentClass.displayName = "StackingComponentHOC(" + ReactHelpers_1.getComponentName(componentType) + ")";
    return newComponentClass;
};
//# sourceMappingURL=StackingComponent.js.map